// 260722 copilot E2-P2 — mapper action button của chatbot: actionId → {label, cost, run}.
// ⚠️ NGUỒN GỐC: labelVi/cost lặp lại từ admin-service/src/utils/filmActionRegistry.ts (FE không đọc
// được registry backend) — sửa registry thì sửa cả đây. Id lạ (backend mới hơn FE) → trả null,
// UI render nút disabled thay vì crash (forward-compat).
import { filmApi } from '../../services/api/film';

export type ActionCost = 'free' | 'ai' | 'money';

export interface ChatActionDef {
  labelVi: string;
  cost: ActionCost;
  needsEventId?: boolean;
  run: (planId: string, eventId?: string) => Promise<unknown>;
}

const DEFS: Record<string, ChatActionDef> = {
  // ── Stage ① ──
  'run-author-dialogue': { labelVi: 'Chạy pass thoại', cost: 'ai', run: (p) => filmApi.authorDialogue(p) },
  'run-directing': { labelVi: 'Chạy pass directing (chia shot)', cost: 'ai', run: (p) => filmApi.directPlan(p) },
  'run-continuity': { labelVi: 'Chạy pass continuity', cost: 'ai', run: (p) => filmApi.checkContinuity(p) },
  'run-durations': { labelVi: 'Tính lại duration', cost: 'free', run: (p) => filmApi.computeDurations(p) },
  'run-fill-narration': { labelVi: 'V.O. fill (lấp event câm)', cost: 'ai', run: (p) => filmApi.fillNarration(p) },
  // ── Stage ② ──
  'run-breakdown-locations': { labelVi: 'Phân tích bối cảnh (spatial layout)', cost: 'ai', run: (p) => filmApi.breakdownLocations(p) },
  'run-prepare-references': { labelVi: 'Chuẩn bị reference (ảnh/voice)', cost: 'money', run: (p) => filmApi.prepareReferences(p) },
  'run-gen-location-plates': { labelVi: 'Gen ảnh bối cảnh (plate)', cost: 'money', run: (p) => filmApi.genLocationPlates(p) },
  // ── Stage ③ ──
  'run-author-prompts': { labelVi: 'Author lại prompt Seedance', cost: 'ai', run: (p) => filmApi.authorEventPrompts(p) },
  // ── Stage ④ ──
  'gen-event-clip': {
    labelVi: 'Gen/regen clip cho event', cost: 'money', needsEventId: true,
    run: (_p, eventId) => {
      if (!eventId) return Promise.reject(new Error('Thiếu event đích cho gen clip'));
      return filmApi.genEvent(eventId);
    },
  },
  // ── Stage ⑤ ──
  'run-assemble': { labelVi: 'Ghép phim (export MP4)', cost: 'money', run: (p) => filmApi.assemblePlan(p) },
  // ── Verify ──
  'run-lint': { labelVi: 'Chấm plan (linter)', cost: 'free', run: (p) => filmApi.lintPlan(p) },
  'run-judge': { labelVi: 'Chấm plan (AI judge)', cost: 'ai', run: (p) => filmApi.judgePlan(p) },
};

/** Resolve id → định nghĩa; id lạ → null (nút disabled, không throw). */
/** 261030 C1 — plan layout four gen video ở bước ④ (hộp giá): trợ lý KHÔNG được gen clip qua `genEvent` (BE cũng chặn 409 LAYOUT_FOUR_USE_VIDEO_ROUTES). */
export const resolveChatAction = (id: string, layoutFour = false): ChatActionDef | null => (layoutFour && id === 'gen-event-clip' ? null : DEFS[id] || null);
